/** 邮箱正则 */
export function validateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}
export const jumpOtherPage = (url) => {
  window.location.href = url;
}

export const picTitleToHyphen = (title) => {
  if (!title) return ''
  return title.split(' ').join('-')
}

export const picTitleToWhitespace = (title) => {
  if (!title) return ''
  return title.split('-').join(' ')
}


export const formatLikes = (likes) => {
  if (likes < 1000) {
    return likes.toString(); // 小于 1,000 直接返回
  } else if (likes < 10000) {
    return (likes / 1000).toFixed(1) + 'K'; // 1K 到 9,999，保留一位小数
  } else if (likes < 100000) {
    return Math.floor(likes / 1000) + 'K'; // 10K 到 99,999，显示为整数 K
  } else {
    return Math.floor(likes / 1000) + 'K'; // 100K 到 999,999，同样显示为整数 K
  }
}
